<template>
    <div class="container" data-cy="facts-api-component">
        <div style="max-width: 100%;margin-top: 10px; margin-bottom: 10px;">
            <div class="title">PTC Wizard Subscription Key <span class="text-muted" style="font-size: small;">(use this subscription key to generate a facts api key)</span></div>
            <div class="d-flex align-center mt-2 gap-4">
                <v-text-field
                    density="comfortable"
                    color="primary"
                    bg-color="white"
                    v-model="$props.facts_subscription_key"
                    style="width: 300px"
                    class="custom-input"
                    :loading="$props.loadingIntegration"
                    disabled
                    data-cy="integration-facts_subscription_key"
                ></v-text-field>
            </div>
        </div>
        <div style="max-width: 100%">
            <div class="title">API Key <span class="text-muted" style="font-size: small;">(insert your api key here to sync data to the PTC Wizard)</span></div>
            <div class="d-flex align-center mt-2 gap-4">
                <v-text-field
                    density="comfortable"
                    color="primary"
                    bg-color="white"
                    v-model="localFactsApiKey"
                    style="width: 300px"
                    class="custom-input"
                    :loading="$props.loadingIntegration"
                    data-cy="integration-facts_api_key"
                    @update:model-value="updateFactsApiKey"
                ></v-text-field>
            </div>
        </div>
        <ecsTaskSync integration_type="facts"/>
    </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import EcsTaskSync from '@/components/school/integration/ecsTaskSync.vue';

const props = defineProps<{
    facts_subscription_key: string;
    facts_api_key: string;
    loadingIntegration: boolean;
}>();

const emit = defineEmits<{
    'update:facts_api_key': [value: string];
    'reload:data': [];
}>();

const localFactsApiKey = ref(props.facts_api_key);

// Watch for prop changes from parent
watch(() => props.facts_api_key, (newValue) => {
    localFactsApiKey.value = newValue;
});

const updateFactsApiKey = (value: string) => {
    emit('update:facts_api_key', value);
};
</script>
<style scoped lang="scss"></style>